export const contentTypes = [
  {
    label: 'Course',
    key: 'course',
    index: 'courses',
    children: [
      {
        label: 'Certificate Program',
        key: 'certificate_program',
      },
      {
        label: 'Individual Course',
        key: 'individual_course',
      },
      {
        label: 'Master Program',
        key: 'master_program',
      },
      {
        label: 'Micro Course',
        key: 'micro_course',
      },
    ],
  },
  {
    label: 'Conference',
    key: 'conference',
    index: 'conferences',
  },
  {
    label: 'Publication',
    key: 'publication',
    index: 'publications',
    children: [
      {
        label: 'Research',
        key: 'research',
        children: [
          {
            label: 'Research Report',
            key: 'research_report',
          },
          {
            label: 'Case Study',
            key: 'case_study',
          },
          {
            label: 'Whitepaper',
            key: 'whitepaper',
          },
        ],
      },
      {
        label: 'Book',
        key: 'book',
      },
      {
        label: 'Magazine',
        key: 'magazine',
        children: [
          {
            label: 'TD Magazine',
            key: 'td_magazine',
          },
        ],
      },
    ],
  },
  {
    label: 'Article',
    key: 'article',
    index: 'articles',
    children: [
      {
        label: 'Newsletter Article',
        key: 'newsletter_article',
      },
      {
        label: 'TD Magazine',
        key: 'td_magazine',
      },
    ],
  },
  {
    label: 'Blog',
    key: 'blog',
    index: 'blogs',
    children: [
      {
        label: 'Professional Partner Content',
        key: 'professional_partner_content',
      },
      {
        label: 'Community Content',
        key: 'community_content',
      },
      {
        label: 'Press Release',
        key: 'press_release',
      },
    ],
  },
  {
    label: 'Page',
    key: 'page',
    index: 'pages',
  },
  {
    label: 'Video',
    key: 'video',
    index: 'videos',
  },
  {
    label: 'Webinar',
    key: 'webinar',
    index: 'webinars',
  },
  {
    label: 'Podcast',
    key: 'podcast',
    index: 'podcasts',
  },
  {
    label: 'People',
    key: 'users',
    index: 'users',
  },
  {
    label: 'Community Discussion',
    key: 'community_discussion',
    // index: '', @todo: add index
  },
  {
    label: 'Performance Resource',
    key: 'performance_resource',
    index: 'performance_resources',
    children: [
      {
        label: 'Templates and Tools',
        key: 'templates_&_Tools',
      },
      {
        label: 'TD at Work Guide',
        key: 'td_at_work_guide',
      },
    ],
  },
]
